import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavDrawer } from './NavDrawer';
import { AnnouncementBar } from './AnnouncementBar';
import { StickyBuyBar, STICKY_BAR_ROUTES } from '../shop/StickyBuyBar';
import { PreCheckoutSheet } from '../checkout/PreCheckoutSheet';
import { NavDrawerProvider } from '../../contexts/NavDrawerContext';
import { initMetaPixel, track } from '../../utils/analytics';
export function SiteLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
    track('page_view', {
      path: pathname
    });
  }, [pathname]);
  return <NavDrawerProvider data-id="element-493" data-mp="3rvery3hym84g">
      <div className="flex min-h-screen w-full flex-col bg-deep text-white" data-id="element-494" data-mp="347x5mnhgs28v">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-marine focus:px-4 focus:py-2" data-id="element-495" data-mp="345u7fg65r2t2">
          Skip to content
        </a>
        <AnnouncementBar data-id="element-496" data-mp="1fbojh71uioue" />
        <Header data-id="element-497" data-mp="1faws68fa7d9x" />
        <main id="main" className="flex-1" data-id="element-498" data-mp="1fadkdkjci59m">
          <Outlet data-id="element-499" data-mp="1k2ww0byh2qbs" />
        </main>
        <Footer data-id="element-500" data-mp="1k3pvcrv3qdjw" />
        {/* Room for the mobile sticky purchase bar so it never covers the footer. */}
        {STICKY_BAR_ROUTES.includes(pathname) && <div className="h-[72px] bg-[#050F1C] lg:hidden" aria-hidden data-id="element-501" data-mp="1o630pf5xs9g5" />}
        <StickyBuyBar data-id="element-502" data-mp="rfk9u2w84kj0" />
        <NavDrawer data-id="element-503" data-mp="rgc5fdptmi9a" />
        <PreCheckoutSheet data-id="element-504" data-mp="wcsss5p74slb" />
      </div>
    </NavDrawerProvider>;
}